<template>
  <div class="socialmedia container-fluid">
    <h2>Never Miss A Beat</h2>
    <div>
      <p>Follow Keep LoLing S2 on these platforms:</p>
      <a id="goto-instagram" href="https://www.instagram.com/keeploling.s2/" aria-label="Keep LoLing S2 Instagram Account" target="_blank" itemprop="url"><i class="fab fa-instagram fa-3x"></i></a>
      <a id="goto-youtube" href="https://www.youtube.com/channel/UCg40EqLY1xwnKdb4sYQ_3ng/" aria-label="Keep LoLing S2 YouTube" target="_blank" itemprop="url"><i class="fab fa-youtube fa-3x"></i></a>
      <a id="goto-twitter" href="https://twitter.com/keeplolings2" aria-label="Keep LoLing S2 Twitter" target="_blank" itemprop="url"><i class="fab fa-twitter fa-3x"></i></a>
      <img src="static/images/logo.png" alt="Keep LoLing S2 Logo"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SocialMedia'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.socialmedia {
  background-color:rgba(240, 128, 128,1);
  position: relative;
  margin-top: 2em;
}
.socialmedia a {
    color: rgba(255, 255, 255,1);
    margin-right: .5em;
}

.socialmedia i {
    padding-top: .25em;
    padding-bottom: 1.5em;
}

.socialmedia a:hover {
    color: rgba(33, 47, 61 ,1);
}

img {
  display: none;
}

@media screen and (min-width: 992px) {
  img {
    display: inline;
    position: absolute;
    max-height: 100%;
    right: 0;
    bottom: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/socialmedia.vue